module.exports = __webpack_public_path__ + "media/images/placeholders/spenden-9acb36aee1ff813a0670991cb14e05a4.jpg";